// extracted by mini-css-extract-plugin
module.exports = {"bigDiv":"Projects_bigDiv__3QUjc","topleft":"Projects_topleft__1p4YQ"};